import StorageMovement from './StorageMovement';

export default StorageMovement;